import { Space, Flex, Text, Grid, Skeleton } from '@mantine/core';
import { InteractiveText } from '../../../../../../component/InteractiveText';
import { Routes } from '../../../../../../route/Routes';
import { useWindowSize } from '../../../../../../hooks';
import { useTranslation } from 'react-i18next';
import { RaffleItem } from '../raffle-item';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useRaffleStore } from '../../RaffleStore';
import { RaffleTime } from '@web/common';
import { EmptyFutureRaffles } from '../../../news';

export const FutureRaffles = observer(
  ({
    limit,
    showHeader = false,
    grow = false,
    showEmptyState = true,
  }: {
    limit?: number;
    showHeader?: boolean;
    grow?: boolean;
    showEmptyState?: boolean;
  }) => {
    const isSmallScreen = useWindowSize(600);
    const { t } = useTranslation('raffle');
    const store = useRaffleStore();
    const hasMoreItems = store.upcomingRaffles?.length > 0;

    useEffect(() => {
      store.loadFutureRaffleData();
    }, [store]);

    const hasRaffles = store.upcomingRaffles?.length > 0;
    const rafflesToShow = limit
      ? store.upcomingRaffles?.slice(0, limit)
      : store.upcomingRaffles;

    return (
      <>
        {showHeader && (
          <>
            <Space h="20px" />
            <Flex justify="space-between">
              <Text size="21px" lh="24px" fw="600">
                {t('UpcomingRaffles')}
              </Text>
              {!isSmallScreen && hasMoreItems && (
                <InteractiveText
                  text={t('ShowAll')}
                  navigateTo={`${Routes.Study}/${Routes.Raffles}/${Routes.FutureRaffles}`}
                />
              )}
            </Flex>
          </>
        )}

        {store.isLoadingFuture ? (
          <Skeleton height={100} radius="8px" />
        ) : hasRaffles ? (
          <Grid grow={grow}>
            {rafflesToShow?.map((raffle) => (
              <Grid.Col span={{ base: 12, md: 6 }} key={raffle.sys.id}>
                <RaffleItem data={raffle} time={RaffleTime.Future} />
              </Grid.Col>
            ))}
          </Grid>
        ) : (
          showEmptyState && <EmptyFutureRaffles />
        )}

        {showHeader && isSmallScreen && hasMoreItems && (
          <InteractiveText
            text={t('ShowAll')}
            navigateTo={`${Routes.Study}/${Routes.Raffles}/${Routes.FutureRaffles}`}
          />
        )}
      </>
    );
  },
);
